// PropertiesReducer.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

// Create the Thunk for fetching property by slug
export const fetchPropertySlug = createAsyncThunk(
  "property/fetchPropertySlug",
  async (slug, { rejectWithValue }) => {
    try {
      const response = await api.get(`/property/slug/:${slug}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);
export const saveSearch = createAsyncThunk(
  "property/saveSearch",
  async (query, { rejectWithValue }) => {
    try {
      const response = await api.post(`/property/query`, query, {
        withCredentials: true,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// Create the Thunk for fetching property by ID
export const fetchPropertyId = createAsyncThunk(
  "property/fetchPropertyId",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await api.get(`/property/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);
// Create the Thunk for fetching property by ID
export const getPropertybyId = createAsyncThunk(
  "property/getPropertybyId",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(`/getPropertybyId`, payload, {
        withCredentials: true,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// Create the Thunk for fetching properties
export const properties = createAsyncThunk(
  "property/properties",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(`/properties`, info, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
// Create the Thunk for fetching properties
export const homeproperties = createAsyncThunk(
  "property/homeproperties",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(`/properties/home`, info, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Create the Thunk for fetching coordinates
export const fetchCoordinates = createAsyncThunk(
  "property/fetchCoordinates",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/coordinates`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// Create the Slice
const propertyReducer = createSlice({
  name: "property",
  initialState: {
    successMessage: "",
    errorMessage: "",
    loader: false,
    properties: [],
    propertys: [],
    commercial: [],
    property: {},
    found: [],
    totalproperty: 5,
    isActive: 0,
    coordinates: [],
    query: {},
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
    property_clear: (state, _) => {
      state.property = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPropertySlug.pending, (state) => {
        state.loader = true;
      })
      .addCase(fetchPropertySlug.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload.error;
      })
      .addCase(fetchPropertySlug.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.property = payload.property;
      })
      .addCase(saveSearch.pending, (state) => {
        state.loader = true;
      })
      .addCase(saveSearch.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload.error;
      })
      .addCase(saveSearch.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.successMessage = payload.message;
      })
      .addCase(fetchPropertyId.pending, (state) => {
        state.loader = true;
      })
      .addCase(fetchPropertyId.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload.error;
      })
      .addCase(fetchPropertyId.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.property = payload.property;
      })
      .addCase(getPropertybyId.pending, (state) => {
        state.loader = true;
      })
      .addCase(getPropertybyId.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload.error;
      })
      .addCase(getPropertybyId.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.property = payload.property;
      })
      .addCase(properties.pending, (state) => {
        state.loader = true;
      })
      .addCase(properties.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload.error;
      })
      .addCase(properties.fulfilled, (state, { meta, payload }) => {
        state.loader = false;
        state.propertys = payload.propertys;
        // if (meta.arg.listingType === "residential") {
        // } else {
        //   state.commercial = payload.propertys;
        // }
        state.totalproperty = payload.totalproperty;
        state.query = payload.query;
      })
      .addCase(homeproperties.pending, (state) => {
        state.loader = true;
      })
      .addCase(homeproperties.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload.error;
      })
      .addCase(homeproperties.fulfilled, (state, { meta, payload }) => {
        state.loader = false;
        state.propertys = payload.propertys;
      })
      .addCase(fetchCoordinates.pending, (state) => {
        state.loader = true;
      })
      .addCase(fetchCoordinates.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload.error;
      })
      .addCase(fetchCoordinates.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.coordinates = payload.coordinates;
      });
  },
});

export default propertyReducer.reducer;

export const { messageClear, property_clear } = propertyReducer.actions;
